import { ControlTemplate } from 'dac-web-ui';
import { Toolbox } from 'dac-web-ui';

export class toolBoxManagerTemplate extends ControlTemplate {
	constructor( modules, managers ) {
		super();
		this.modules = modules;
		this.managers = managers;
		
		this.modules.toolbox = Toolbox;
	}

	enableControl( name, enable = true ) {
		const button = document.querySelector( `#${name}` );
		if ( !button ) return;

		button.style.pointerEvents = enable ? 'auto' : 'none';
		button.style.opacity = enable ? 1 : 0.5;
	}

	disable( target, currentTarget ) {
		if( target ) target.style.pointerEvents = 'none';	
		if( currentTarget ) currentTarget.style.pointerEvents = 'none';
	}

	enable( target, currentTarget ) {
		if( target ) target.style.pointerEvents = '';	
		if( currentTarget ) currentTarget.style.pointerEvents = '';
	}

	_addVLineAfterButton( id ) {
		const button = document.querySelector( `#${id}` );
		if ( !button ) return;

		const line = document.createElement( 'div' );
		line.className = 'toolboxLine';
		button.parentNode.insertBefore( line, button.nextSibling );
	}

	toggleButton( e, icontext1, icontext2 ) {
		
		const targets = { t: e.target, c: e.currentTarget };
		let target = null;
		if( targets.t.className === 'toolboxIcon' ) {
			target = targets.t;
		} else if ( targets.c.className === 'toolboxIcon' ) {
			target = targets.c;
		}
		if( target.innerText === icontext1 ) target.innerText = icontext2;
		else if ( target.innerText === icontext2 ) target.innerText = icontext1;
	}
}